import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/meta/user-vip.png'
import _imports_1 from '@/assets/images/member/vip-icon.png'
import _imports_2 from '@/assets/images/member/vip-gray-icon.png'
import _imports_3 from '@/assets/images/member/vip-c-icon.png'
import _imports_4 from '@/assets/images/member/vip-c-gray-icon.png'
import _imports_5 from '@/assets/images/member/crown-icon.png'
import _imports_6 from '@/assets/images/avatar.png'
import _imports_7 from '@/assets/images/avatar-tag.png'
import _imports_8 from '@/assets/images/tip-close.png'


const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = { class: "top-container-tabs" }
const _hoisted_3 = { class: "tab-label" }
const _hoisted_4 = { class: "top-container-item" }
const _hoisted_5 = { style: {"width":"138px"} }
const _hoisted_6 = { class: "upgrade-lists" }
const _hoisted_7 = { class: "upgrade-title" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "equity-list" }
const _hoisted_10 = { class: "list1" }
const _hoisted_11 = { class: "list2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  style: {"cursor":"pointer"},
  src: _imports_0,
  width: "138",
  height: "24"
}, null, -1)
const _hoisted_13 = { class: "message-area" }
const _hoisted_14 = { class: "problem-popover-container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-changjianwentixinshouyindao" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-shipinjiaochengxinshouyindao" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "icon-item" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon default",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-wenti" })
  ]),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon hover",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-a-wentixuanzhong" })
  ])
], -1)
const _hoisted_18 = { class: "message-popover-container" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-xiaoxitixing1" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon default",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-xiaoxitixing" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon hover",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-a-xiaoxitixingxuanzhong1" })
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_25 = { class: "lang" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_27 = { class: "popover-container" }
const _hoisted_28 = { class: "popover-header" }
const _hoisted_29 = { class: "nickname" }
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "equity-des" }
const _hoisted_32 = {
  key: 0,
  class: "status-new"
}
const _hoisted_33 = { class: "status status-active" }
const _hoisted_34 = {
  class: "time",
  style: {"margin-bottom":"14px"}
}
const _hoisted_35 = { class: "time" }
const _hoisted_36 = {
  key: 0,
  class: "vip-bg",
  src: _imports_1
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  class: "vip-bg",
  src: _imports_2
}, null, -1)
const _hoisted_38 = {
  key: 0,
  class: "vip-icon",
  src: _imports_3
}
const _hoisted_39 = {
  key: 1,
  class: "vip-icon",
  src: _imports_4
}
const _hoisted_40 = { class: "popover-content" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-jibenxinxi" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-wodedingdan" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-wodequanyi" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-jibenxinxi" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-chongzhi" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-s-check",
  style: {"margin-right":"9px"}
}, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "icon-detect" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tuichudenglu1" }, null, -1)
const _hoisted_49 = {
  key: 0,
  class: "vip-tag",
  src: _imports_5
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  class: "avatar",
  src: _imports_6
}, null, -1)
const _hoisted_51 = {
  key: 1,
  class: "avatar-tag",
  src: _imports_7
}
const _hoisted_52 = {
  key: 0,
  class: "role-list"
}
const _hoisted_53 = ["onClick", "title"]
const _hoisted_54 = { class: "roleName" }
const _hoisted_55 = {
  key: 0,
  class: "message-box-area"
}
const _hoisted_56 = { class: "message-bg" }
const _hoisted_57 = { class: "message-list" }
const _hoisted_58 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_PrivacyModal = _resolveComponent("PrivacyModal")!
  const _component_guiji_layout = _resolveComponent("guiji-layout")!

  return (_openBlock(), _createBlock(_component_guiji_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_tabs, {
            class: "top-tabs",
            type: "card",
            closable: "",
            editable: "",
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = $event)),
            onEdit: _ctx.handleTabsEdit,
            onTabClick: _ctx.onTabClick
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabsArr, (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  name: `${item.name}`,
                  key: item.key
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      class: "item",
                      effect: "dark",
                      content: item.name.split('&')[0],
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(item.name.split('&')[0]), 1)
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onEdit", "onTabClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            false
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  "popper-class": "member-upgrade",
                  placement: "bottom",
                  width: "360",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _hoisted_12
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.lang('home.vip.set')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equityList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "upgrade-list",
                          key: index
                        }, [
                          _createElementVNode("img", {
                            src: item.url,
                            width: "40",
                            height: "40"
                          }, null, 8, _hoisted_8),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1),
                            _createElementVNode("div", _hoisted_11, _toDisplayString(item.content), 1)
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("div", {
                        class: "upgrade-btn",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSubscribe && _ctx.handleSubscribe(...args)))
                      }, _toDisplayString(_ctx.lang('home.upload')), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_popover, {
              placement: "bottom",
              width: 120,
              trigger: "click",
              "popper-class": "problem-popover",
              "show-arrow": false,
              visible: _ctx.problemPopoverVisible,
              "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.problemPopoverVisible = $event))
            }, {
              reference: _withCtx(() => [
                _hoisted_17
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "item",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleOpenUrl('https://cdn.guiji.cn/vpp/vpp/pdf/1507259736721215489.pdf')))
                  }, [
                    _hoisted_15,
                    _createTextVNode(_toDisplayString(_ctx.lang('header.guide.commonProblem')), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "item",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleOpenUrl('https://cdn.guiji.cn/vpp/vpp/mp4/1507253474453377026.mp4')))
                  }, [
                    _hoisted_16,
                    _createTextVNode(_toDisplayString(_ctx.lang('header.guide.videoTutorial')), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_el_popover, {
              "popper-class": "message-popover",
              placement: "bottom-end",
              width: "160",
              "show-arrow": false,
              visible: _ctx.messagePopoverVisible,
              "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.messagePopoverVisible = $event))
            }, {
              reference: _withCtx(() => [
                _createElementVNode("span", {
                  class: "icon-item",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleShowMessage && _ctx.handleShowMessage(...args)))
                }, [
                  _createVNode(_component_el_badge, {
                    value: _ctx.systemMessage?.unReadCount,
                    max: 99,
                    hidden: !_ctx.systemMessage?.unReadCount,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22,
                      _hoisted_23
                    ]),
                    _: 1
                  }, 8, ["value", "hidden"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.unReadMessageList.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unReadMessageList, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "message-item",
                            key: item.id,
                            onClick: _withModifiers(($event: any) => (_ctx.handleViewMessage(item.id)), ["stop"])
                          }, [
                            _hoisted_20,
                            _hoisted_21,
                            _createTextVNode(" " + _toDisplayString(item.title), 1)
                          ], 8, _hoisted_19))
                        }), 128)),
                        _createElementVNode("div", {
                          class: "footer",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handleViewMessage('all')), ["stop"]))
                        }, _toDisplayString(_ctx.lang('common.text.more')) + ">> ", 1)
                      ], 64))
                    : (_openBlock(), _createBlock(_component_el_empty, {
                        key: 1,
                        "image-size": 60,
                        description: _ctx.noDataDes
                      }, null, 8, ["description"]))
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]),
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("span", {
              class: _normalizeClass([_ctx.chromeLang === 'zh' && 'active']),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.langChange('zh')))
            }, "中", 2),
            _createElementVNode("span", {
              class: _normalizeClass([_ctx.chromeLang === 'en' && 'active']),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.langChange('en')))
            }, "EN", 2)
          ]),
          _hoisted_26,
          _createVNode(_component_el_popover, {
            "popper-class": "user-info-popover",
            placement: "bottom-end",
            trigger: "hover",
            width: "240",
            "show-arrow": false,
            visible: _ctx.popoverVisible,
            "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => (_ctx.popoverVisible = $event))
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_badge, { "is-dot": false }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["avatar-con", _ctx.vipInfo && _ctx.vipInfo.vip ? 'avatar-con-active' : ''])
                  }, [
                    (_ctx.vipInfo && _ctx.vipInfo.vip)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_49))
                      : _createCommentVNode("", true),
                    _hoisted_50,
                    (_ctx.partnerInfo)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_51))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.nickname || _ctx.username), 1),
                  _createElementVNode("div", {
                    class: "account",
                    title: _ctx.username
                  }, _toDisplayString(_ctx.lang('mainAccount.info.account')) + "：" + _toDisplayString(_ctx.username), 9, _hoisted_30),
                  false
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["equity-status", _ctx.vipInfo && _ctx.vipInfo.vip ? 'equity-status-active' : ''])
                      }, [
                        _createElementVNode("div", _hoisted_31, [
                          (!_ctx.vipInfo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.lang('home.vip.tip')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.vipInfo)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.TranslationTitle(_ctx.vipInfo)), 1),
                                _createElementVNode("div", _hoisted_34, [
                                  _createTextVNode(_toDisplayString(_ctx.vipInfo?.expireTime.substring(0, 10)) + _toDisplayString(_ctx.vipInfo?.subscribe
                          ? _ctx.lang('home.vip.expired.auto')
                          : _ctx.lang('home.vip.expired')) + " | ", 1),
                                  _createElementVNode("span", {
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleSubscribeTable && _ctx.handleSubscribeTable(...args)))
                                  }, _toDisplayString(_ctx.lang('home.vip.open')) + ">", 1)
                                ]),
                                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.vipInfo && _ctx.vipInfo.vip
                          ? `${_ctx.lang('home.vip.enjoy', [_ctx.ownTime])}`
                          : `${_ctx.lang('home.vip.expired.tip', [_ctx.overdueTime])}`), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "btn btn-active",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleSubscribe && _ctx.handleSubscribe(...args)))
                          }, _toDisplayString(_ctx.vipInfo && _ctx.vipInfo.vip ? _ctx.lang('home.vip.more') : _ctx.lang('home.vip.subNow')), 1)
                        ]),
                        (_ctx.vipInfo && _ctx.vipInfo.vip)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                          : _createCommentVNode("", true),
                        _hoisted_37
                      ], 2))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.vipInfo && _ctx.vipInfo.vip)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_38))
                          : (_openBlock(), _createElementBlock("img", _hoisted_39))
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  false
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "content-item",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (
                  _ctx.handleOpenTab({
                    title: _ctx.lang('common.text.basicInformation'),
                    url: '/accountSetting',
                  })
                ))
                      }, [
                        _hoisted_41,
                        _createTextVNode(_toDisplayString(_ctx.lang('common.text.basicInformation')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "content-item",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (
                  _ctx.handleOpenTab({ title: _ctx.lang('common.text.myOrder'), url: '/vshow/videoOrder' })
                ))
                  }, [
                    _hoisted_42,
                    _createTextVNode(_toDisplayString(_ctx.lang('common.text.myOrder')), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "content-item",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (
                  _ctx.handleOpenTab({
                    title: _ctx.lang('mainMenu.myMenu.accountManagement'),
                    url: '/vshow/accountManage',
                  })
                ))
                  }, [
                    _hoisted_43,
                    _createTextVNode(_toDisplayString(_ctx.lang('common.text.myInterests')), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "content-item",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (
                  _ctx.handleOpenTab({
                    title: _ctx.lang('mainMenu.myMenu.accountManagement'),
                    url: '/vshow/accountManage',
                  })
                ))
                  }, [
                    _hoisted_44,
                    _createTextVNode(_toDisplayString(_ctx.lang('mainMenu.myMenu.accountManagement')), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "content-item",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (
                  _ctx.handleOpenTab({
                    title: _ctx.lang('mainMenu.myMenu.diamondTopUp'),
                    url: '/vshow/diamondTopUp',
                  })
                ))
                  }, [
                    _hoisted_45,
                    _createTextVNode(_toDisplayString(_ctx.lang('mainMenu.myMenu.diamondTopUp')), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "content-item",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleOpenPrivacy && _ctx.handleOpenPrivacy(...args)))
                  }, [
                    _hoisted_46,
                    _createTextVNode(_toDisplayString(_ctx.lang('mainMenu.myMenu.privacy')), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "content-item",
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteAccount && _ctx.handleDeleteAccount(...args)))
                  }, [
                    _hoisted_47,
                    _createTextVNode(_toDisplayString(_ctx.lang('mainMenu.myMenu.deleteAccount')), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "content-item",
                    onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["stop"]))
                  }, [
                    _hoisted_48,
                    _createTextVNode(_toDisplayString(_ctx.lang('mainAccount.info.logout')), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_el_popover, {
            "popper-class": "role-popper",
            placement: "bottom-end",
            trigger: "hover",
            width: "110"
          }, _createSlots({
            default: _withCtx(() => [
              (_ctx.roles.length > 1)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_52, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: role.type,
                        onClick: ($event: any) => (_ctx.changeRole(role.type, _ctx.router)),
                        title: role?.roleName
                      }, [
                        _createElementVNode("span", null, _toDisplayString(role?.roleName), 1)
                      ], 8, _hoisted_53))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (_ctx.roles.length > 1)
              ? {
                  name: "reference",
                  fn: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ role: true, multiple: _ctx.roles.length > 1 })
                    }, [
                      _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.currRole?.roleName), 1)
                    ], 2)
                  ])
                }
              : undefined
          ]), 1024)
        ]),
        (_ctx.systemMessage.message?.type == 0 && _ctx.systemMessage.message?.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("span", null, _toDisplayString(_ctx.systemMessage.message?.title), 1),
                _createElementVNode("img", {
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.hasReadMessage && _ctx.hasReadMessage(...args))),
                  class: "img",
                  src: _imports_8
                })
              ]),
              _createElementVNode("div", _hoisted_57, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatSysMessageList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "message-item",
                    key: index
                  }, _toDisplayString(item), 1))
                }), 128))
              ]),
              (_ctx.systemMessage.message?.attachmentUrl)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handleOpenMessageLink && _ctx.handleOpenMessageLink(...args))),
                    class: "footer"
                  }, _toDisplayString(_ctx.lang('home.vip.seeNow')) + ">> ", 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_router_view),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MICRO_CONF, (item) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: item.name,
          id: item.container.slice(1)
        }, null, 8, _hoisted_58)), [
          [_vShow, _ctx.currentMicro.startsWith(item.activeRule.split('#')[1])]
        ])
      }), 128)),
      _createVNode(_component_PrivacyModal, {
        visible: _ctx.privacyVisible,
        "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => (_ctx.privacyVisible = $event))
      }, null, 8, ["visible"])
    ]),
    _: 1
  }))
}